// Example quick actions for demo mode
import { Stethoscope, Pill, Calendar, FileText, Utensils, Brain } from 'lucide-react';

export const exampleQuickActions = [
  { icon: Stethoscope, label: 'Log Symptom', color: 'bg-gradient-to-br from-red-500 to-red-600' },
  { icon: Pill, label: 'Add Medication', color: 'bg-gradient-to-br from-blue-500 to-blue-600' },
  { icon: Utensils, label: 'Quick Log Meal', color: 'bg-gradient-to-br from-orange-500 to-red-500' },
  { icon: Calendar, label: 'Schedule Appointment', color: 'bg-gradient-to-br from-green-500 to-green-600' },
  { icon: Brain, label: 'AI Analysis', color: 'bg-gradient-to-br from-purple-500 to-purple-600' },
  { icon: FileText, label: 'Add Note', color: 'bg-gradient-to-br from-slate-500 to-slate-600' },
]; 